"use client";
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    Hashtag: function() {
        return Hashtag;
    },
    default: function() {
        return _default;
    }
});
const _jsxruntime = require("react/jsx-runtime");
const _utils = require("@mui/material/utils");
const Hashtag = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxruntime.jsx)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M9.08305 2.00345C9.63342 2.04931 10.0424 2.53266 9.99655 3.08304L9.67013 6.99999H15.6632L16.0035 2.91695C16.0493 2.36657 16.5327 1.95758 17.083 2.00345C17.6334 2.04931 18.0424 2.53266 17.9965 3.08304L17.6701 6.99999H21C21.5523 6.99999 22 7.44771 22 7.99999C22 8.55228 21.5523 8.99999 21 8.99999H17.5035L17.0035 15H20C20.5523 15 21 15.4477 21 16C21 16.5523 20.5523 17 20 17H16.8368L16.4965 21.083C16.4507 21.6334 15.9673 22.0424 15.417 21.9965C14.8666 21.9507 14.4576 21.4673 14.5035 20.9169L14.8299 17H8.8368L8.49655 21.083C8.45068 21.6334 7.96733 22.0424 7.41695 21.9965C6.86658 21.9507 6.45759 21.4673 6.50345 20.9169L6.82987 17H3C2.44772 17 2 16.5523 2 16C2 15.4477 2.44772 15 3 15H6.99653L7.49653 8.99999H4C3.44772 8.99999 3 8.55228 3 7.99999C3 7.44771 3.44772 6.99999 4 6.99999H7.6632L8.00345 2.91695C8.04932 2.36657 8.53267 1.95758 9.08305 2.00345ZM9.50347 8.99999L9.00347 15H14.9965L15.4965 8.99999H9.50347Z",
        fill: "currentColor"
    })
}), "Hashtag");
const _default = Hashtag;
